module.exports = __webpack_public_path__ + "img/ly.8a80b3dc.svg";